module.exports = __webpack_public_path__ + "static/media/boiler.6e8f5b1d.PNG";